import { getEnvironmentStage } from '../util/envUtils';

export const STAGES = {
  BETA: 'beta',
  GAMMA: 'gamma',
  PROD: 'prod',
  UNKNOWN_STAGE: 'UNKNOWN_STAGE',
};

export const DOMAIN = {
  [STAGES.BETA]: 'beta.nudge-ui.hr',
  [STAGES.PROD]: 'nudge-ui.hr',
  [STAGES.GAMMA]: 'gamma.nudge-ui.hr',
};

export const HOSTS = {
  [STAGES.BETA]: 'https://iakvd4dzc4.execute-api.us-east-1.amazonaws.com/beta',
  [STAGES.PROD]: 'https://r289b20fv7.execute-api.us-east-1.amazonaws.com/prod',
};

export const SUPPORT_SIM_LINK =
  'https://issues.amazon.com/issues/create?assignedFolder=03beb42e-6c36-4c2c-b834-2910c4bfbf95';

export const GET_USER_ACCESS_GROUPS = `getUserAccessGroups`;
export const REGISTER_ACCESS_GROUPS = `registerAccessGroup`;
export const GET_USER_PERMISSION = `getUserPermission`;

export const CREATE_NEW_SEGMENT_WITH_RULES = `createSegment`;

export const CREATE_NEW_SEGMENT_USING_S3_URL = `createSegmentFromS3`;

export const CREATE_SEGMENT_FROM_FILE_URL = `createSegmentWithInputData`;

export const GET_ALL_MESSAGE_TEMPLATES_URL = `getAllMessageTemplates`;

export const GET_MESSAGE_TEMPLATE_DETAILS_URL = `getMessageTemplateDetails`;

export const GET_ALL_SEGMENTS_URL = `getAllSegments`;

export const CREATE_MESSAGE_TEMPLATE_URL = `createMessageTemplate`;

export const UPDATE_MESSAGE_TEMPLATE = 'updateMessageTemplate';

export const DELETE_MESSAGE_TEMPLATE = 'deleteMessageTemplate';

export const CREATE_SCHEDULE_URL = `createCampaign`;

export const DELETE_SEGMENT_URL = `deleteSegment`;

export const DOWNLOAD_SEGMENT_URL = `downloadSegment`;

export const UPLOAD_IMAGE_TO_S3 = 'uploadImageToS3';

export const GET_ALL_CAMPAIGN_URL = 'getAllCampaigns';

export const DELETE_CAMPAIGN_URL = 'deleteCampaign';

export const CREATE_CAMPAIGN_JOURNEY = 'createCampaignJourney';

export const SEND_NOTIFICATION_URL = 'sendNotification';

export const GET_ALL_CAMPAIGN_METRIC_URL = 'getAllCampaignsMetric';

export const GET_CAMPAIGN_METRICS_URL = "getCampaignMetrics"

export const UPDATE_SEGMENT_URL = 'updateSegment';

export const GET_PRESIGNED_UPLOAD_URL = 'getPresignedUploadURL';
